import React from "react";
import compose from "lodash/flowRight";
import {graphql} from "react-apollo";
import get from "lodash/get";
import gql from "graphql-tag";
import {withTranslation, Constants} from "@unibuddy/intl";
import {isFeatureEnabled} from "shared/Utils/FeatureUtils";
import MentorCarousel from "shared/Widgets/MentorCarousel/components/MentorCarousel/MentorCarousel";
import universityFragment from "shared/University/fragments/universityFragment";
import {GlobalCssVariable} from "shared/Styling/hocs/withCSSVariables";
import withAnalytics from "shared/AnalyticsNew/withAnalytics/withAnalytics";
import withSourceTracking from "shared/SourceTracking/withSourceTracking/withSourceTracking";
import {productSpec} from "shared/AnalyticsNew/constants/productSpecification";
import {getParameterByName} from "shared/Utils/UrlUtils";

const query = gql`
    query RandomMentorListQuery($universitySlug: String!, $limit: LimitedInt, $ubLang: String) {
        university(slug: $universitySlug) {
            ...UniversityFull
            universityWidgetUrls: widgetUrls(selectedLocale: $ubLang) {
                url
            }
        }
        randomMentorsList(universitySlug: $universitySlug, safeLimit: $limit) {
            mentors {
                id
                profilePhoto(raw: true)
                firstName
                degree {
                    id
                    name
                }
                lastSeen
                country {
                    id
                    code
                }
                mentorFields {
                    primaryFlag {
                        code
                    }
                    secondaryFlag {
                        code
                    }
                }
                placeName
            }
        }
    }
    ${universityFragment}
`;

export function getRedirectUrl(widgetUrl, mentorId) {
    if (mentorId !== undefined) {
        const path = `inbox/chatwith/${mentorId}`;
        try {
            const url = new URL(widgetUrl);
            url.searchParams.set("unibuddy", path);
            return url.toString();
        } catch (error) {
            console.log(error);
        }
    }
    return widgetUrl;
}

export class MentorCarouselWidget extends React.Component {
    componentDidMount() {
        // Record Product Opened Event
        this.props.analytics.events.productOpened({
            name: productSpec.embeddedUniversityCarousel.NAME,
            universitySlug: this.props.match.params.universitySlug,
            ubLang: this.props?.i18n?.language ?? Constants.DEFAULT_LOCALE,
        });
    }

    onChatNow = (mentorId) => {
        const widgetUrl = get(this.props.university, "universityWidgetUrls[0].url", null);
        if (widgetUrl) {
            const url = getRedirectUrl(widgetUrl, mentorId);
            window.open(this.props.sourceTracking.redirectWithSourceTracking(url), "_blank");
        }
    };

    onSeeMore = () => {
        const widgetUrl = get(this.props.university, "universityWidgetUrls[0].url", null);
        if (widgetUrl) {
            const url = getRedirectUrl(widgetUrl);
            window.open(this.props.sourceTracking.redirectWithSourceTracking(url), "_blank");
        }
    };

    render() {
        const isShowCountryFlagEnabled = isFeatureEnabled("showCountryFlag", this.props.university);

        return (
            <React.Fragment>
                {this.props.university && (
                    <GlobalCssVariable
                        name="--theme-primary"
                        value={`#${this.props.university.colour}`}
                    />
                )}
                <MentorCarousel
                    loading={this.props.loading}
                    onChatNow={this.onChatNow}
                    onSeeMore={this.onSeeMore}
                    mentors={this.props.mentors}
                    isShowCountryFlagEnabled={isShowCountryFlagEnabled}
                />
            </React.Fragment>
        );
    }
}

export default compose(
    withAnalytics,
    withSourceTracking,
    withTranslation("common"),
    graphql(query, {
        props({data: {loading, university, randomMentorsList}}) {
            return {
                loading,
                university,
                mentors: get(randomMentorsList, "mentors", []),
            };
        },
        options(props) {
            return {
                variables: {
                    universitySlug: props.match.params.universitySlug,
                    limit: 5,
                    ubLang: getParameterByName(props.location.search, "ub_lang"),
                },
            };
        },
    }),
)(MentorCarouselWidget);
